import { createFileRoute } from '@tanstack/react-router';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { MewsTeam, RouteType } from '@mews/enums';
import { GuestProfileContractingTab } from '@mews-commander/contracts';
import { getCustomerNameToDocumentTitle } from '../-utils';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Customer/$id/_sidebarLayout/Contracting')({
    beforeLoad: ({ context: { checkFeatureFlag } }) => {
        checkFeatureFlag(FeatureFlag.contractingCustomerProfileDocumentsEnabled);
        checkFeatureFlag(FeatureFlag.newCustomerPageRouteStructureEnabled);
    },
    loader: async ({ params: { id }, context: { ensureQueryData } }) =>
        await getCustomerNameToDocumentTitle({ ensureQueryData, id }),
    staticData: {
        owner: MewsTeam.Spacetime,
        type: RouteType.Frontend,
        title: TextKey.ContractGuestProfileTabTitle,
    },
    component: Component,
});

function Component() {
    const { id } = Route.useParams();

    return <GuestProfileContractingTab customerId={id} />;
}
